enum CalendarViewtype {
  Month = 'month',
  Week = 'week',
  Day = 'day',
}

export default CalendarViewtype
